/**
 * @generated SignedSource<<25e32442917adb17eb2c441f2af3a391>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeliveryOrderCancelInput = {
  cancelReason: string;
  id: string;
};
export type DeliveryOrderCancelDialog_deliveryOrderCancelMutation$variables = {
  input: DeliveryOrderCancelInput;
};
export type DeliveryOrderCancelDialog_deliveryOrderCancelMutation$data = {
  readonly deliveryOrderCancel: {
    readonly cancelReason: string | null;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder" | "DeliveryOrderMutationActionsButtonStack_deliveryOrder" | "DeliveryOrderStatusLabel_deliveryOrder">;
  };
};
export type DeliveryOrderCancelDialog_deliveryOrderCancelMutation = {
  response: DeliveryOrderCancelDialog_deliveryOrderCancelMutation$data;
  variables: DeliveryOrderCancelDialog_deliveryOrderCancelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelReason",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "before",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "after",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeliveryOrderCancelDialog_deliveryOrderCancelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeliveryOrder",
        "kind": "LinkedField",
        "name": "deliveryOrderCancel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DeliveryOrderStatusLabel_deliveryOrder"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DeliveryOrderMutationActionsButtonStack_deliveryOrder"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeliveryOrderCancelDialog_deliveryOrderCancelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeliveryOrder",
        "kind": "LinkedField",
        "name": "deliveryOrderCancel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Stuff",
            "kind": "LinkedField",
            "name": "stuff",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DeliveryAddress",
            "kind": "LinkedField",
            "name": "deliveryAddress",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recipientName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recipientNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressDetail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zipCode",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "DeliveryOrderHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DeliveryOrderHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DeliveryOrderHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "picture",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDeleted",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "difference",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDifference"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "description",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "address",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "addressDetail",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "zipCode",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "recipientName",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "recipientNumber",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "stuffTitle",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "title",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "DeliveryOrderDifference",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10)"
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b078e51dabf8559e9a4a4ef5246913d",
    "id": null,
    "metadata": {},
    "name": "DeliveryOrderCancelDialog_deliveryOrderCancelMutation",
    "operationKind": "mutation",
    "text": "mutation DeliveryOrderCancelDialog_deliveryOrderCancelMutation(\n  $input: DeliveryOrderCancelInput!\n) {\n  deliveryOrderCancel(input: $input) {\n    id\n    cancelReason\n    ...DeliveryOrderStatusLabel_deliveryOrder\n    ...DeliveryOrderMutationActionsButtonStack_deliveryOrder\n    ...DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder\n  }\n}\n\nfragment DeliveryOrderCancelDialog_deliveryOrder on DeliveryOrder {\n  id\n}\n\nfragment DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder on DeliveryOrder {\n  histories(first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...DeliveryOrderHistoryDialog_deliveryOrderHistory\n        ...DeliveryOrderHistoryTimelineItem_deliveryOrderHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment DeliveryOrderDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on DeliveryOrderDifference {\n    description {\n      __typename\n    }\n    address {\n      __typename\n    }\n    addressDetail {\n      __typename\n    }\n    zipCode {\n      __typename\n    }\n    recipientName {\n      __typename\n    }\n    recipientNumber {\n      __typename\n    }\n    stuffTitle {\n      __typename\n    }\n    title {\n      __typename\n    }\n  }\n}\n\nfragment DeliveryOrderDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on DeliveryOrderDifference {\n    description {\n      ...DiffItem_diff\n    }\n    address {\n      ...DiffItem_diff\n    }\n    addressDetail {\n      ...DiffItem_diff\n    }\n    zipCode {\n      ...DiffItem_diff\n    }\n    recipientName {\n      ...DiffItem_diff\n    }\n    recipientNumber {\n      ...DiffItem_diff\n    }\n    stuffTitle {\n      ...DiffItem_diff\n    }\n    title {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment DeliveryOrderHistoryDialog_deliveryOrderHistory on DeliveryOrderHistory {\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...DeliveryOrderDifferenceCounterLabel_difference\n    ...DeliveryOrderDifferenceItemList_difference\n  }\n}\n\nfragment DeliveryOrderHistoryTimelineItem_deliveryOrderHistory on DeliveryOrderHistory {\n  id\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  created\n  type\n}\n\nfragment DeliveryOrderMutationActionsButtonStack_deliveryOrder on DeliveryOrder {\n  id\n  actions\n  ...DeliveryOrderUpdateDialog_deliveryOrder\n  ...DeliveryOrderCancelDialog_deliveryOrder\n}\n\nfragment DeliveryOrderStatusLabel_deliveryOrder on DeliveryOrder {\n  status\n}\n\nfragment DeliveryOrderUpdateDialog_deliveryOrder on DeliveryOrder {\n  id\n  type\n  description\n  title\n  stuff {\n    id\n  }\n  deliveryAddress {\n    recipientName\n    recipientNumber\n    address\n    addressDetail\n    zipCode\n    id\n  }\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "a0de14be2c64f3dd2a83f4750bb7c16d";

export default node;
